import LazyLoading from './common/lazyLoading';
import LoadPurchase from './common/loadPurchase.js';
import LoadSpeechSearch from './components/loadSpeechSearch.js';
import CartDrawer from './common/cartDrawer';
import Footer from './common/footer';
import Header from './common/header';
import Webforms from './common/webforms';
import Price from './components/price/price.js';
import { NewsletterComponent } from './components/vndaComponents.js';
import { setSearch, landingPage } from './components/utilities';
import setTopBar from './components/topBar.js';

// ==========================================
// Inicialização
// ==========================================
console.log(
  '%cOlist - Soluções de vendas online e Serviços de E-commerce',
  'color: #0a4ee4; font-size: 14px; font-family: "Verdana", sans-serif; font-weight: bold;'
);

window.addEventListener('DOMContentLoaded', () => {
  Header.init();
  Price.init();
  LazyLoading.init();
  LoadPurchase.init();
  LoadSpeechSearch.init()
  CartDrawer.init();
  Footer.init();
  Webforms.init();
  NewsletterComponent.init();
  setSearch();
  setTopBar();
  landingPage();
});
